import { createSlice } from "@reduxjs/toolkit";

const initialState={
    user:{
        id:"",
        name:"",
        email:"",
        picture:"",
    _id:"",
    status:"",
        token:"",
    },
    status:"",
    error:"",
}

  export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
      logout: (state) => {
        state.status = "";
        state.error = "";
        state.user = {
          _id: "",
          id: "",
          name: "",
          email: "",
          picture: "",
          status: "",
          token: "",
        };
      },
      setAdminUser: (state, action) => {
        const payload = action.payload || {};
        state.user = {
          _id: payload.id || payload._id || "__admin__",
          id: payload.id || payload._id || "__admin__",
          name: payload.name || "Admin",
          email: payload.email || "",
          picture: payload.picture || "https://ui-avatars.com/api/?name=Admin",
          status: payload.role || "admin",
          token: payload.token || state.user.token || "",
        };
        state.status = "succeeded";
        state.error = "";
      },
      changeStatus: (state, action) => {
        state.status = action.payload;
      },
    },
    extraReducers() {},
  });

export const {logout, setAdminUser} = userSlice.actions;

export default userSlice.reducer